import { useAdminMe } from "@/features/admin-auth/api/adminAuthApi";
import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";

interface Props {
  children: ReactNode;
}

export function AdminProtectedRoute({ children }: Props) {
  const location = useLocation();
  const { isPending, error } = useAdminMe();

  if (isPending) {
    return (
      <main className="flex min-h-screen items-center justify-center bg-app-bg">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-app-border border-t-app-emerald" />
      </main>
    );
  }

  if (error) {
    const redirect = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/admin/login?redirect=${redirect}`} replace />;
  }

  return <>{children}</>;
}
